/**
 * useComplianceServiceTypes — OPS 3.7 step 3: the service-type options for a
 * jurisdiction, derived server-side from that jurisdiction's ACTIVE Compliance
 * Templates (GET /v1/templates/service-types). Replaces the hardcoded
 * COMPLIANCE_SERVICES_BY_JURISDICTION list. Legacy items whose serviceType is
 * in no template are unaffected — callers render unknown values as plain
 * strings (the form select appends the current value as an extra option).
 */

import { useQuery } from '@tanstack/react-query';
import { getAccessToken, authenticatedFetch as fetch } from '../lib/auth-context.js';
import { httpError } from '../lib/http-error.js';

export function useComplianceServiceTypes(jurisdiction: string | null | undefined) {
  const query = useQuery({
    queryKey: ['compliance-service-types', jurisdiction],
    enabled: !!jurisdiction,
    staleTime: 30_000,
    queryFn: async () => {
      const res = await fetch(`/v1/templates/service-types?jurisdiction=${encodeURIComponent(jurisdiction!)}`, {
        headers: { Authorization: `Bearer ${getAccessToken() ?? ''}` },
      });
      if (!res.ok) throw await httpError(res);
      const body = await res.json() as { ok: true; data: { items: string[] } };
      return body.data.items;
    },
  });
  return { ...query, serviceTypes: query.data ?? [] };
}
